import { render, staticRenderFns } from "./QuestionBirdsEyeView.vue?vue&type=template&id=2846ed54&scoped=true"
import script from "./QuestionBirdsEyeView.vue?vue&type=script&lang=js"
export * from "./QuestionBirdsEyeView.vue?vue&type=script&lang=js"
import style0 from "./QuestionBirdsEyeView.vue?vue&type=style&index=0&id=2846ed54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2846ed54",
  null
  
)

export default component.exports